import { render, staticRenderFns } from "./BasicsInfo.vue?vue&type=template&id=0e751b77&scoped=true"
import script from "./BasicsInfo.vue?vue&type=script&lang=js"
export * from "./BasicsInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicsInfo.vue?vue&type=style&index=0&id=0e751b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e751b77",
  null
  
)

export default component.exports